import React, { useContext, useEffect } from 'react'
import { Box, Button, Typography } from '@mui/material'
import numeral from 'numeral'
import PropTypes from 'prop-types'

import { ColorBoxContent } from '../../../../../common/ui/colorBox'
import { CheckIcon } from '../../../../../common/ui/icons'
import JoyrideContext from '../../../../../context/joyride/joyrideContext'
export default function OrderReview(props) {
  const {
    children,
    planId,
    plans,
    numberOfSims,
    totalPrice,
    addOnPrice,
    unexpectedError,
    nextHandler,
    goPreviousPage
  } = props
  const joyrideContext = useContext(JoyrideContext)
  const { tourActive, setRun } = joyrideContext

  useEffect(() => {
    if (tourActive) {
      setTimeout(() => {
        setRun(true)
      }, 500)
    }
  }, [])

  return (
    <div id='buyNewSim__orderReview'>
      <Box sx={{ padding: '0px 24px', width: '100%' }}>
        <Typography variant='h4'>Please Review Your Order Details</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <Box width='60%'>
            <Typography variant='subtitle1' sx={{ marginBottom: '24px' }}>
              Ensure that the information entered is correct. Upon confirmation,
              an email will be sent to the provided email address which will
              contain a URL to check the status of the order.
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            width: '100%'
          }}
        >
          {/* Select Plan Column */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              margin: '24px 0'
            }}
          >
            <ColorBoxContent
              variant='secondary'
              style={{ padding: 0, width: '100%', minHeight: '512px' }}
            >
              <Box
                sx={{
                  padding: `24px 0 16px 16px`
                }}
              >
                <Typography variant='h4' sx={{ margin: 0 }}>
                  Plan Selected
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  backgroundColor: 'primary.main',
                  padding: '16px 4px'
                }}
              >
                <Typography variant='h4' sx={{ color: 'white' }}>
                  {plans[planId].productName}
                </Typography>
                <Typography variant='h4' sx={{ color: 'white' }}>
                  SGD${plans[planId].baseplan.price.value.toFixed(2)}/mth
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '12px'
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <Typography>
                    <b>Breakdown</b>
                  </Typography>
                  <Typography>
                    <b>
                      {numberOfSims} x SGD$
                      {plans[planId].baseplan.price.value.toFixed(2)}
                    </b>
                  </Typography>
                </Box>
                <Box display='flex' flexDirection='row' alignItems='center'>
                  <CheckIcon />
                  <Typography sx={{ margin: '4px' }}>
                    {numeral(plans[planId].baseplan.data * 1000).format('0b')}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <CheckIcon />
                  <Typography sx={{ margin: '4px' }}>
                    {plans[planId].baseplan.voice} min
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <CheckIcon />
                  <Typography sx={{ margin: '4px' }}>
                    {plans[planId].baseplan.sms} SMS
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <CheckIcon />
                  <Typography sx={{ margin: '4px' }}>
                    100% customizable
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '40px'
                  }}
                >
                  <Typography>
                    <b>Add-Ons</b>
                  </Typography>
                  <Typography>
                    <b>SGD${addOnPrice.toFixed(2)}</b>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <CheckIcon />
                  <Typography sx={{ margin: '4px' }}>None</Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: '40px'
                  }}
                >
                  <Typography>
                    <b>Total Price</b>
                  </Typography>
                  <Typography>
                    <b>SGD${totalPrice.toFixed(2)}/mth</b>
                  </Typography>
                </Box>
              </Box>
              {/* end here */}
            </ColorBoxContent>
          </Box>

          {/* Details Column */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '36px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                justifyContent: 'flex-start',
                marginRight: 40
              }}
            >
              <Typography
                sx={{
                  width: '90%'
                }}
              >
                {children}
                <Typography sx={{ color: 'error' }}>
                  {unexpectedError}
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            marginRight: '20px'
          }}
        >
          <Button
            variant='secondary'
            onClick={goPreviousPage}
            data-cy='orderReviewBackBtn'
          >
            Back
          </Button>
          <div id='buyNewSim__orderReviewNextBtn'>
            <Button
              variant='filled'
              onClick={nextHandler}
              data-cy='orderReviewNextBtn'
            >
              Next
            </Button>
          </div>
        </Box>
      </Box>
    </div>
  )
}

OrderReview.propTypes = {
  children: PropTypes.node,
  planId: PropTypes.number.isRequired,
  plans: PropTypes.array.isRequired,
  numberOfSims: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
  addOnPrice: PropTypes.number.isRequired,
  unexpectedError: PropTypes.string.isRequired,
  nextHandler: PropTypes.func.isRequired,
  goPreviousPage: PropTypes.func.isRequired
}
